import Vue from 'vue';
import Vuex from 'vuex';

import { mutations } from './storeMutators';
import { actions } from './storeActions';

const state = {
    answers: {},
    completions: {},
    helpCounter: 0,
    postFillButtonHidden: false,
    debugger: {},

    // Analyst Search Regions:
    regions: [],
    counties: [],
    municipalities: [],
    // Analyst Survey Answers export:
    allProvince: false,
    selectedRegions: {
        regions: [],
        counties: [],
    },
    exportBuildings: false,
    selectedAnswers: {
        s1: [],
        s2: [],
        s3: [],
        s4: [],
        s5: [],
        s6: [],
        s7: [],
        s8: [],
        s9: [],
    },
};

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
Vue.config.debug = debug;

export default new Vuex.Store({
    state,
    mutations,
    actions,

    strict: debug,
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuex/store.js